module.exports = __webpack_public_path__ + "img/myIdCardBg.950d1aaa.png";